// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__3srm5","footer":"ReportModalFilter_footer__28RtN"};